module.exports = __webpack_public_path__ + "static/media/S3N11-1.c9324990.svg";